// extracted by mini-css-extract-plugin
export default {"container":"OnevocaSearchInput_container__xY986","searchImage":"OnevocaSearchInput_searchImage__P7msi","searchInput":"OnevocaSearchInput_searchInput__U2ofb"};